import React from "react";

const CXTransformationLayout = () => {
    return (
        <div className="bg-white">

            {/* ================= HERO ================= */}
            <section
                className="relative h-[520px] flex items-center text-white"
                style={{
                    backgroundImage:
                        "linear-gradient(rgba(10,10,20,.8), rgba(10,10,20,.8)), url(https://images.unsplash.com/photo-1517430816045-df4b7de11d1d)",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="relative w-full px-6 md:px-16 lg:px-24 py-24 text-white text-left">
                    <span className="uppercase text-sm tracking-wide text-orange-400">
                        Services
                    </span>
                    <h1 className="text-4xl md:text-5xl font-bold mt-3 mb-4">
                        CX Transformation
                    </h1>
                    <p className="max-w-2xl text-lg text-gray-200 mb-6">
                        Redefine how your business connects, engages, and delivers value to
                        customers across every touchpoint.
                    </p>
                    <button className="bg-orange-500 hover:bg-orange-600 px-6 py-3 rounded-md font-semibold">
                        Consult Our Experts
                    </button>
                </div>
            </section>

            {/* ================= FEATURED INSIGHT ================= */}
            <section className="py-14 border-b">
                <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-10">
                    <div>
                        <h3 className="text-xl font-semibold mb-2">
                            Recognized for CX Excellence
                        </h3>
                        <p className="text-gray-600">
                            Delivering enterprise-grade CX platforms, analytics, and
                            experience-led innovation.
                        </p>
                    </div>
                    <div className="flex items-center justify-center">
                        <img
                            src="/images/partners/salesforce.png"
                            alt="Salesforce"
                            className="h-10"
                        />
                    </div>
                </div>
            </section>

            {/* ================= AI CX STRATEGY ================= */}
            <section
                className="py-24 text-white"
                style={{
                    background:
                        "linear-gradient(120deg, #020617, #020617)",
                }}
            >
                <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
                    <div>
                        <h2 className="text-3xl font-bold mb-4">
                            AI-Powered CX Strategies
                        </h2>
                        <p className="text-gray-300 mb-6">
                            Harness AI, data, and cloud platforms to personalize journeys,
                            predict intent, and deliver meaningful customer experiences at
                            scale.
                        </p>
                        <button className="border border-white px-6 py-3 rounded-md">
                            Download the Report
                        </button>
                    </div>
                    <div>
                        <img
                            src="https://images.unsplash.com/photo-1551836022-d5d88e9218df"
                            alt="AI CX"
                            className="rounded-xl shadow-xl"
                        />
                    </div>
                </div>
            </section>

            {/* ================= CX TRANSFORMATION ================= */}
            <section className="py-20">
                <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-10">
                    <div>
                        <h3 className="text-2xl font-bold mb-3">
                            CX Transformation
                        </h3>
                        <p className="text-gray-600 mb-4">
                            Redesign customer journeys using behavioral insights, intelligent
                            automation, and experience platforms.
                        </p>
                        <button className="text-orange-500 font-semibold">
                            Learn more →
                        </button>
                    </div>

                    <div>
                        <h4 className="font-semibold mb-2">Our Offerings</h4>
                        <ul className="text-sm text-gray-600 space-y-2">
                            <li>• Experience Strategy</li>
                            <li>• Digital Enablement</li>
                            <li>• CX Platform Engineering</li>
                            <li>• Data & Analytics</li>
                        </ul>
                    </div>
                </div>
            </section>

            {/* ================= STRETCHING HORIZON ================= */}
            <section
                className="py-20 text-white"
                style={{
                    backgroundImage:
                        "linear-gradient(rgba(0,0,0,.7), rgba(0,0,0,.7)), url(https://images.unsplash.com/photo-1504384308090-c894fdcc538d)",
                    backgroundSize: "cover",
                }}
            >
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-4">
                        Stretching the Horizon to Unlock Business Potential
                    </h2>
                    <button className="border border-white px-6 py-3 rounded-md">
                        Read Customer Stories
                    </button>
                </div>
            </section>

            {/* ================= WHY TechSPR ================= */}
            <section className="py-20 bg-gray-50">
                <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-8">
                    {[
                        {
                            title: "Extensive Salesforce Knowledge",
                            text: "Deep platform expertise delivering scalable CX solutions."
                        },
                        {
                            title: "Industry Accelerators",
                            text: "Pre-built frameworks for faster CX modernization."
                        },
                        {
                            title: "Exceptional Delivery",
                            text: "Global delivery excellence with measurable outcomes."
                        }
                    ].map((item) => (
                        <div key={item.title} className="bg-white p-6 rounded-xl shadow">
                            <h4 className="font-semibold mb-2">{item.title}</h4>
                            <p className="text-sm text-gray-600">{item.text}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* ================= CLIENT SUCCESS ================= */}
            <section className="py-20 bg-[#020617] text-white">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-10">Client Success</h2>

                    <div className="grid md:grid-cols-3 gap-8">
                        {[
                            {
                                img: "/images/cxtransformation/cs1.jpg",
                                title: "Retail analytics enabling real-time inventory decisions",
                                cta: "Read case study →",
                            },
                            {
                                img: "/images/cxtransformation/cs2.png",
                                title: "Healthcare platforms improving patient data visibility",
                                cta: "View success story →",
                            },
                            {
                                img: "/images/cxtransformation/cs3.png",
                                title: "SaaS transformation driving product-led growth",
                                cta: "Explore results →",
                            },
                        ].map((item, index) => (
                            <div
                                key={index}
                                className="bg-white text-black rounded-xl overflow-hidden"
                            >
                                <img
                                    src={item.img}
                                    alt={item.title}
                                    className="w-full h-48 object-cover"
                                    loading="lazy"
                                />

                                <div className="p-5">
                                    <h4 className="font-semibold mb-2 text-lg">
                                        {item.title}
                                    </h4>

                                    <button className="text-orange-500 font-semibold">
                                        {item.cta}
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>


            {/* ================= NEWS ================= */}
            {/* <section className="py-20 bg-[#020617] text-white">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-10">News & Insights</h2>
                    <div className="grid md:grid-cols-3 gap-8">
                        {[1, 2, 3].map((i) => (
                            <div key={i} className="bg-white text-black rounded-xl p-5">
                                <h4 className="font-semibold mb-2">
                                    Transforming CX with AI & Data
                                </h4>
                                <button className="text-orange-500 font-semibold">
                                    Read More →
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </section> */}

            {/* ================= CONTACT ================= */}
            {/* <section className="py-20">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-8">Contact Us</h2>
                    <form className="grid md:grid-cols-2 gap-6">
                        <input className="border p-3 rounded" placeholder="First name" />
                        <input className="border p-3 rounded" placeholder="Last name" />
                        <input className="border p-3 rounded" placeholder="Work email" />
                        <input className="border p-3 rounded" placeholder="Company" />
                        <textarea
                            className="border p-3 rounded md:col-span-2"
                            placeholder="How can we help?"
                            rows="4"
                        />
                        <button className="bg-orange-500 text-white px-6 py-3 rounded-md font-semibold">
                            Submit
                        </button>
                    </form>
                </div>
            </section> */}

        </div>
    );
};

export default CXTransformationLayout;
